import axios from 'axios';
import config from 'config';
import { dataResponseInterceptor, unauthenticatedRequestInterceptor } from 'domains/api/interceptors';

export const proxyAPIClient = axios.create({
  baseURL: config.get('apiProxyBaseUrl'),
  headers: {
    'Content-type': 'application/json',
  },
});

proxyAPIClient.interceptors.request.use(...unauthenticatedRequestInterceptor);

proxyAPIClient.interceptors.response.use(...dataResponseInterceptor);
